import React from 'react';
import PropTypes from 'prop-types';
import Question from '../../assets/question.svg';
import Close from '../../assets/Close.svg';


class BasicSearch extends React.Component {
  state = {
    placeholderVisible: true,
    value: this.props.searchField,
  };

  static getDerivedStateFromProps(props, state) {
    if (props.searchField !== state.value) {
      return {
        value: props.searchField,
      };
    }
    return null;
  }

  handleFocus = () => {
    this.setState({
      placeholderVisible: false,
    });
  }

  handleBlur = () => {
    if (this.state.value === '') {
      this.setState({
        placeholderVisible: true,
      });
    }
  }

  handleChange = (event) => {
    this.setState({
      value: event.target.value,
    });
    this.props.onChange(event.target.value);
  }

  render() {
    const { placeholderVisible, value } = this.state;
    const { filteredMovies, removeSearchField, searchField, brandClass } = this.props;
    return (
      <div className="react-basic-search-container">
        <div className="react-basic-search-title">
          {`Összesen ${filteredMovies.length ? filteredMovies.length : 0} film`}
        </div>
        <div className="react-basic-search">
          {value === ''
            ? <Question className={`react-basic-search-placeholder-question react-mozi-brand ${brandClass}`} />
            : <Close className={`react-basic-search-placeholder-close react-mozi-brand ${brandClass}`} onClick={() => { removeSearchField(); }} />
          }
          <input
            className={`react-basic-search-input react-mozi-brand ${brandClass}`}
            placeholder={placeholderVisible ? 'Tudod mit szeretnél megnézni? Keress!' : ''}
            name="search"
            type="text"
            value={searchField}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            onChange={this.handleChange}
          />
        </div>
      </div>
    );
  }
}

BasicSearch.propTypes = {
  onChange: PropTypes.func.isRequired,
  removeSearchField: PropTypes.func.isRequired,
  searchField: PropTypes.string.isRequired,
  brandClass: PropTypes.string,
  filteredMovies: PropTypes.arrayOf(PropTypes.shape({})),
};

BasicSearch.defaultProps = {
  filteredMovies: null,
  brandClass: 'react-artmozi',
};

export default BasicSearch;
